import React from "react";
import PropTypes from "prop-types";

export class FuxRating extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.rating !== this.props.rating;
    }

    handleClick = idx => _ => {
        if (this.props.onChange) this.props.onChange(idx + 1);
    }

    render() {

        const rating = +(parseInt(this.props.rating).toFixed(0));

        return (
            <React.Fragment>
                {
                    [...new Array(rating)].map(
                        (v, i) => <i key={i} className={"fas fa-star " + this.props.className}
                                     onClick={this.handleClick(i)}
                                     style={this.props.style}/>
                    )
                }
                {
                    this.props.showMissingStars &&
                    [...new Array(5 - rating)].map(
                        (v, i) => <i key={i} className={"far fa-star " + this.props.className}
                                     onClick={this.handleClick(i + rating)}
                                     style={this.props.style}/>
                    )
                }
            </React.Fragment>
        )
    }
}

FuxRating.propTypes = {
    rating: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
    showMissingStars: PropTypes.bool,
    onChange: PropTypes.func,
}

FuxRating.defaultProps = {
    className: 'text-success',
    style: {},
    showMissingStars: true
}
